import { useEffect } from 'react'

type Props = {
  open: boolean
  onClose: () => void
}

const steps = [
  '予約時間になりましたら、「診察をはじめる」ボタンをタップします',
  'お名前を本名で入力します',
  'マイクとカメラのアクセスを許可します',
]

export default function ReservationGuideModal({ open, onClose }: Props) {
  useEffect(() => {
    if (!open) return
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', handleEsc)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleEsc)
      document.body.style.overflow = ''
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="reservation-guide-title"
      className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[12px] max-w-[321px] w-full min-h-min p-4 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="reservation-guide-title" className="text-[16px] font-medium text-center mt-2 mb-4">
          事前準備・利用方法
        </h2>
        <ol className="text-left list-none pl-[40px] text-[14px]">
          {steps.map((step, i) => (
            <li
              key={i}
              className="ml-[25px] mr-[10px] my-[20px] relative list-item"
            >
              <span className="absolute -left-[44px] -top-[5px] w-[30px] h-[30px] rounded-full text-[#04aae4] border border-[#04aae4] box-border flex items-center justify-center">
                {i + 1}
              </span>
              <p className="my-[5px]">{step}</p>
            </li>
          ))}
          <li className="ml-[25px] mr-[10px] my-[20px] relative list-item">
            <span className="absolute -left-[44px] -top-[5px] w-[30px] h-[30px] rounded-full text-[#04aae4] border border-[#04aae4] box-border flex items-center justify-center">
              4
            </span>
            <p className="my-[5px]">はじめに本人確認を行いますので、身分証明書をご提示ください</p>
            <p className="my-[5px]">※ビデオ通話は外部サービスWherebyを使って行います</p>
            <a className="block text-[#04aae4]" href="https://whereby.com/" target="_blank" rel="noopener noreferrer">
              https://whereby.com/
            </a>
          </li>
        </ol>
        <button
          type="button"
          onClick={onClose}
          className="block border-none bg-transparent underline text-[#97979a] text-[12px] mt-[10px] mx-auto mb-[16px] text-center w-full"
        >
          閉じる
        </button>
      </div>
    </div>
  )
}
